export default function () {
  document
    .getElementById("getInTouch")
    .scrollIntoView({ behavior: "smooth", block: "center" });
}
